import React from 'react'
import PropTypes from 'prop-types'
import { Transition, TransitionGroup } from 'react-transition-group'
import { gsap, ScrollSmoother, ScrollTrigger } from 'gsap-wrapper'
import ThemeProvider from 'styles/theme-provider'
import CookiesBanner from 'components/ui-elements/cookies-banner'

import 'styles/fonts.css'
import GlobalStyle from 'styles/global-styles'
import { LayoutWrapper, PageWrapper, ContentWrapper } from './index.styled'

const LayoutContent = ({ children, location, scrollSmoother }) => {
  return (
    <TransitionGroup component={null}>
      <Transition
        key={location.pathname}
        timeout={{ enter: 100, exit: 0 }}
        onEntered={() => {
          if (scrollSmoother.current) {
            setTimeout(() => {
              scrollSmoother.current.scrollTop(0, false)
            }, 10)
          }
        }}
      >
        {(status) => (
          <div className={`page ${status}`}>
            <LayoutWrapper>{children}</LayoutWrapper>
          </div>
        )}
      </Transition>
    </TransitionGroup>
  )
}

const Layout = (props) => {
  const { children, location } = props
  const refWrapper = React.useRef(null)
  const scrollSmoother = React.useRef(null)

  React.useLayoutEffect(() => {
    const gsapContext = gsap.context(() => {
      scrollSmoother.current = ScrollSmoother.create({
        content: '.home-content',
        wrapper: '.home-wrapper',
        smooth: 2,
        effects: true,
        smoothTouch: 1,
      })

      const timeout = setTimeout(() => {
        gsap.utils
          .toArray(
            '.fadeIn, .fadeInTitleFromBottom, .fadeInFromBottom, .slideInFromTop, .slideInFromLeft, .copyColsLine',
          )
          .forEach(function (container) {
            ScrollTrigger.create({
              trigger: container,
              start: 'top 90%',
              end: '+=1000%',
              toggleClass: {
                targets: container,
                className: 'visible',
                toggle: 'add',
              },
              once: true,
            })
          })
      }, 300)
      return () => clearTimeout(timeout)
    }, [refWrapper])

    return () => gsapContext.revert()
  }, [children])

  return (
    <ThemeProvider location={location} scrollSmoother={scrollSmoother}>
      <div className="home-wrapper" ref={refWrapper}>
        <div className="home-content">
          <PageWrapper>
            <GlobalStyle />
            <ContentWrapper>
              <LayoutContent
                location={location}
                scrollSmoother={scrollSmoother}
              >
                {children}
              </LayoutContent>
            </ContentWrapper>
          </PageWrapper>
        </div>
        <CookiesBanner />
      </div>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
}

export default Layout
